// Generated types for VersioningOp
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { VersioningRowReadAPI, VersioningRowWriteAPI } from './versioningrow';
import { VersioningRowReadAPISchemaObject, VersioningRowWriteAPISchemaObject } from './versioningrow';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningOpReadAPI extends VersioningRowReadAPI {
  /** The island root's id (the engine's key; never a caller's). */
  island_id: string;
  /** Content-addressed op id (hash of semantic content + deps). */
  op_id: string;
  /** Stamping commit id; null = uncommitted working op. */
  commit_id?: string | null;
  /** The branch line the op was appended on. */
  branch?: string;
  /** Full op payload as JSON (ops.Op.to_dict()). */
  data: string;
  /** Append timestamp (Neo4j clock). */
  ts?: number | null;
  /** In-batch order tiebreak. */
  idx?: number | null;
  /** When the proposal this op belongs to closed (Neo4j clock); null while it is working. */
  closed_at?: number | null;
  /** How the proposal closed: accepted | rejected | withdrawn. */
  closed_as?: string | null;
  /** The write transaction (changeset) the op came from. */
  changeset_id?: string | null;
}

export interface VersioningOpWriteAPI extends VersioningRowWriteAPI {
  /** Content-addressed op id (hash of semantic content + deps). */
  op_id: string;
  /** Stamping commit id; null = uncommitted working op. */
  commit_id?: string | null;
  /** The branch line the op was appended on. */
  branch?: string;
  /** Full op payload as JSON (ops.Op.to_dict()). */
  data: string;
  /** Append timestamp (Neo4j clock). */
  ts?: number | null;
  /** In-batch order tiebreak. */
  idx?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningOpReadAPISchema: z.ZodType<VersioningOpReadAPI> = VersioningRowReadAPISchemaObject.extend({
  island_id: z.string(),
  op_id: z.string(),
  commit_id: z.string().nullable().optional(),
  branch: z.string().optional(),
  data: z.string(),
  ts: z.number().nullable().optional(),
  idx: z.number().nullable().optional(),
  closed_at: z.number().nullable().optional(),
  closed_as: z.string().nullable().optional(),
  changeset_id: z.string().nullable().optional(),
}).passthrough();

export const VersioningOpWriteAPISchema: z.ZodType<VersioningOpWriteAPI> = VersioningRowWriteAPISchemaObject.extend({
  op_id: z.string(),
  commit_id: z.string().nullable().optional(),
  branch: z.string().optional(),
  data: z.string(),
  ts: z.number().nullable().optional(),
  idx: z.number().nullable().optional(),
}).passthrough();
